<template v-if="loaded">
    <form class="main-header__search-form" method="get" :action="formAction()">
        <div class="main-header__search-item">
        <input class="main-header__search-input" type="text" name="search" :placeholder="placeholder">
        <button class="main-header__search-submit" type="submit">
                <Icon name="search" />
            <span class="visually-hidden">Zoeken</span>
        </button>
        </div>
    </form>
</template>

<script>
import { store } from './store.js'
import Icon from './Icon.vue';


export default {
    name: 'HeaderSearchInput',
    data() {
        return {
            active: false,
            loaded: false,
            placeholder: false,
            store,
        };
    },
    components: {
        Icon
    },
    props: ['input'],
    watch: {
        'store.activeToggle': function() {
            this.setActivePlaceholder();
        }
    },
    mounted: function() {
        this.setActivePlaceholder();
            
        this.loaded = true;
    },
    methods: {
        setActivePlaceholder() {
            this.placeholder = this.store.searchLabelVacancies;
        },
        formAction() {
            let url = '';

            url = 'vacatures';
            
            return `${window.SITE_URL}/${url}/`;
        }
    }
};
</script>